import React, { useEffect } from "react";

import { Card, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { DataStore } from "aws-amplify";
import { useTranslation } from "react-i18next";
import moment from "moment";

import renderOrderStatus from "../../utils/renderOrderStatus";
import { Order, OrderStatus } from "../../models";
import { useAppContext } from "../../context/app-context";

export default function Orders() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurants } = useAppContext();

  const [orders, setOrders] = React.useState<Order[]>([]);

  /**
   * Query Order filtered by
   * ACCEPTED, NEW, COOKING AND READY_FOR_PICKUP ORDERS
   */
  useEffect(() => {
    if (!restaurants) {
      return;
    }

    DataStore.query(Order, (order) =>
      order.and((order) => [
        order.or((o) => [
          o.status.eq(OrderStatus.ACCEPTED),
          o.status.eq(OrderStatus.COOKING),
          o.status.eq(OrderStatus.NEW),
          o.status.eq(OrderStatus.READY_FOR_PICKUP),
        ]),
      ])
    )
      .then((data) => {
        const sortedByCreationDate = data
          .sort(
            // @ts-ignore
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          )
          .reverse();
        return sortedByCreationDate;
      })
      .then(setOrders);
  }, [restaurants]);

  /**
   * Observe Model Order of type INSERT & matching to restaurant id
   */
  useEffect(() => {
    const subscription = DataStore.observe(Order).subscribe(
      ({ opType, element }) => {
        console.log({ opType, element, restaurants });
        if (
          opType === "INSERT"
          // && element.orderRestaurantId === restaurant?.id
        ) {
          setOrders((existingOrders) => [element, ...existingOrders]);
        }
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [restaurants]);

  const tableColumns = [
    {
      title: t("app.orders.restaurant-id"),
      dataIndex: "orderRestaurantId",
      key: "orderRestaurantId",
      render: (restaurantId: string) =>
        restaurants?.find((rest) => rest?.id === restaurantId)?.name,
    },
    { title: t("app.orders.order-id"), dataIndex: "id", key: "id" },
    {
      title: t("app.orders.created-at"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string) => moment(createdAt).fromNow(),
    },
    {
      title: t("app.orders.price"),
      dataIndex: "total",
      key: "total",
      render: (price: number) => `${price} €`,
    },
    {
      title: t("app.orders.status"),
      dataIndex: "status",
      key: "status",
      render: renderOrderStatus,
    },
  ];

  const onClickedOnRow = (orderItem: Order) => {
    console.log(orderItem);
    navigate(`order/${orderItem.id}`);
  };

  return (
    <Card title={t("app.orders.title")}>
      <Table
        dataSource={orders}
        columns={tableColumns}
        rowKey={"id"}
        onRow={(orderItem) => ({
          onClick: () => onClickedOnRow(orderItem),
        })}
      />
    </Card>
  );
}
